import { Badge } from "@/components/ui/badge";
import { AWARD_STYLES } from "@/lib/prizes";

/** "Prize draw" / "Top student" pill. Nothing for plain unlock prizes. */
export default function AwardStyleBadge({ style, className }) {
  if (!style || style === "unlock") return null;
  const { label, icon: Icon } = AWARD_STYLES[style];
  return (
    <Badge variant="accent" className={`gap-1 whitespace-nowrap font-sans ${className || ""}`}>
      <Icon className="h-3 w-3" aria-hidden="true" />
      {label}
    </Badge>
  );
}
